import { motion } from "framer-motion";

const sections = [
  {
    title: "1. Veri Sorumlusu",
    content: `
6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca kişisel verileriniz, veri sorumlusu sıfatıyla Aysun Şeremet tarafından işlenebilecektir.

Bu metin, kişisel verilerinizin hangi kapsamda işlendiği ve KVKK kapsamındaki haklarınız hakkında sizleri bilgilendirmek amacıyla hazırlanmıştır.
`
  },
  {
    title: "2. İşlenen Kişisel Veriler",
    content: `
Web sitesi üzerinden bizimle iletişime geçtiğinizde veya hizmetlerimiz hakkında bilgi talep ettiğinizde aşağıdaki kişisel verileriniz işlenebilir:
• Ad ve soyad
• Telefon numarası
• E-posta adresi
• Mesaj ve başvuru içerikleri
• Randevu bilgileri
• IP adresi ve teknik kullanım verileri
`
  },
  {
    title: "3. Kişisel Verilerin İşlenme Amaçları",
    content: `
Kişisel verileriniz aşağıdaki amaçlarla işlenebilir:
• Danışmanlık ve iletişim süreçlerinin yürütülmesi
• Randevu taleplerinin alınması ve planlanması
• Kullanıcı taleplerinin değerlendirilmesi
• Hizmet kalitesinin artırılması
• Yasal yükümlülüklerin yerine getirilmesi
`
  },
  {
    title: "4. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi",
    content: `
Kişisel verileriniz;
• web sitesi iletişim formları
• e-posta iletişimi
• telefon iletişimi
• dijital iletişim kanalları

aracılığıyla elektronik ortamda toplanabilmektedir.

Bu veriler, KVKK’nın 5. ve 6. maddelerinde belirtilen hukuki sebepler doğrultusunda işlenmektedir. Bu kapsamda kişisel verileriniz;
• açık rızanızın bulunması
• bir sözleşmenin kurulması veya ifası
• veri sorumlusunun hukuki yükümlülüğünü yerine getirmesi
• veri sorumlusunun meşru menfaatleri

hukuki sebeplerine dayanarak işlenebilir.
`
  },
  {
    title: "5. Kişisel Verilerin Aktarılması",
    content: `
Kişisel verileriniz;
• kanunen yetkili kamu kurum ve kuruluşlarına
• yasal yükümlülüklerin yerine getirilmesi amacıyla ilgili kurumlara
• teknik altyapı ve hosting hizmeti sağlayan iş ortaklarına

gerekli olduğu ölçüde ve KVKK hükümlerine uygun şekilde aktarılabilir.
`
  },
  {
    title: "6. Veri Sahibinin Hakları",
    content: `
KVKK’nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:
• Kişisel verilerinizin işlenip işlenmediğini öğrenme
• İşlenmişse buna ilişkin bilgi talep etme
• Verilerin işlenme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme
• Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme
• Eksik veya yanlış işlenmişse düzeltilmesini isteme
• KVKK kapsamında silinmesini veya yok edilmesini talep etme
• Bu işlemlerin verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme
• Otomatik sistemler aracılığıyla analiz edilmesi sonucu aleyhinize bir sonucun ortaya çıkmasına itiraz etme
• Kanuna aykırı işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme
`
  },
  {
    title: "7. Veri Güvenliği",
    content: `
Kişisel verilerinizin hukuka aykırı olarak işlenmesini ve erişilmesini önlemek, verilerin güvenliğini sağlamak amacıyla veri sorumlusu tarafından gerekli teknik ve idari tedbirler alınmaktadır. Kişisel veriler, ilgili mevzuat kapsamında gerekli olan süre boyunca muhafaza edilmekte ve sürenin sona ermesi halinde mevzuata uygun şekilde silinmekte, yok edilmekte veya anonim hale getirilmektedir.
`
  },
  {
    title: "8. Başvuru ve İletişim",
    content: `
KVKK kapsamındaki haklarınıza ilişkin taleplerinizi aşağıdaki iletişim adresi üzerinden iletebilirsiniz.

E-posta: info@aysunseremet.com
`
  }
];

export default function KVKK() {
  return (
    <section className="bg-gray-50 py-24 px-6 lg:px-12">
      <motion.div
        className="max-w-4xl mx-auto text-center space-y-6"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        <h1 className="text-4xl font-bold text-gray-900">
          KVKK Aydınlatma Metni
        </h1>
        <p className="text-gray-600 text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed">
          Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında kişisel verilerinizin hangi amaçlarla işlendiği, kimlere aktarılabileceği, veri toplama yöntemleri ve haklarınız hakkında sizleri bilgilendirmek amacıyla hazırlanmıştır.
        </p>
      </motion.div>

      <div className="mt-16 max-w-3xl mx-auto space-y-6">
        {sections.map((section, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{
              duration: 0.8,
              delay: index * 0.1,
              ease: "easeInOut",
            }}
          >
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {section.title}
            </h2>

            {section.content.split("\n").map((line, i) =>
              line.trim() ? (
                <p
                  key={i}
                  className="text-gray-700 leading-relaxed mb-2 whitespace-pre-line"
                >
                  {line}
                </p>
              ) : null
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}